import { render } from "./poll.vue?vue&type=template&id=5e9dea28"
import script from "./poll.js?vue&type=script&lang=js"
export * from "./poll.js?vue&type=script&lang=js"

import "./poll.vue?vue&type=style&index=0&id=5e9dea28&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__